import BaseEntity                 from '@/core/misc/BaseEntity';
import Utils                      from '@/core/utils/Utils';
import TenderParticipationService from '@/domains/TenderParticipation/TenderParticipationService';
import TYPES                      from '@/core/services/Changelogs/types';
import Core                       from '@/core/Core';
import SupplyOffer                from '@/domains/SupplyOffers/SupplyOffer';
import TendersService             from '@/domains/Tenders/TendersService';
import Title_ru_RU                from "@/core/misc/decorators/Title_ru_RU";
import Title_ru_RU_Class          from "@/core/misc/decorators/Title_ru_RU_Class";
import { type Diff } from "@/core/services/Changelogs/ChangelogFormatters";

type RefusalReason = {
  id:   number;
  name: string;
};

@Title_ru_RU_Class('Участие в тендере')
class ParticipationDetailProduct extends BaseEntity {

  @Title_ru_RU('отработан', TYPES.BOOLEAN_MARK)
  isProcessed:              boolean | null = null;

  @Title_ru_RU('участник', TYPES.BOOLEAN_MARK)
  private _participation:   boolean | null = null;

  @Title_ru_RU('причины отказа', TYPES.REFUSAL_REASONS)
  refusalReasons:           any[]          = [];

  @Title_ru_RU('специфичная причина отказа', TYPES.STRING)
  refusalReasonCustomText:  string | null  = null;

  @Title_ru_RU('разрешение на поставку', TYPES.OBJECT)
  supplyOffer:              SupplyOffer | null = null;

  @Title_ru_RU('тендер', TYPES.OBJECT)
  tender:                   any | null     = null;


  static fromServer(participationDetailProductData: any, result: ParticipationDetailProduct = new ParticipationDetailProduct()): ParticipationDetailProduct {
    super.fromServer(participationDetailProductData, result);

    if (typeof participationDetailProductData.participation === 'boolean') {
      result._participation = participationDetailProductData.participation;
    }

    result.supplyOffer = Core.utils.hydrate(participationDetailProductData.supplyOffer, SupplyOffer.fromServer);

    return result;
  }

  get participation(): boolean | null {
    return this._participation;
  }

  getPartner(): any {
    return this.supplyOffer?.seller;
  }

  getManufacturer(): any {
    return this.supplyOffer?.manufacturer;
  }

  getSupplyOfferStatus(): any {
    return Core.dictionaries.supplyOfferStatuses.get(this.supplyOffer!.status?.id);
  }

  getSupplyOfferStatusAvailability(): any {
    return Core.dictionaries.supplyOfferStatusesAvailability.get(this.supplyOffer!.statusAvailability?.id);
  }

  getRefusalReasonsStringRepresentation(): string {
    if (Utils.isEmptyArray(this.refusalReasons)) {
      return 'Причины отказа нет';
    }

    return [...this.refusalReasons]
      .map(reason => {
        let result = reason.name;
        if (reason.id === 2) {
          result += ' - ' + (this.refusalReasonCustomText ?? '');
        }
        return result;
      })
      .join(', ');
  }

  /**
   * Почему нельзя указать или изменить причину неучастия по этой записи.
   * По исключённому из торгов разрешению отказываться не от чего.
   */
  getReasonCannotSetRefusalReasons(): string | null {
    if (this.supplyOffer!.isExcludedFromTenders === true) {
      return TendersService.UNAVAILABILITY_REASONS.IS_EXCLUDED_FROM_TENDERS;
    }
    else {
      return null;
    }
  }

  setParticipation(value: boolean): void {
    this._participation = value;
    this.isProcessed    = true;
  }

  setRefusalReasons(reasons: any[]): Promise<any> {
    this.refusalReasons = reasons;
    return this.updateRefusalReasons();
  }

  updateRefusalReasons(): Promise<any> {
    let result: any[] = [];

    if (Utils.isNotEmptyArray(this.refusalReasons)) {
      result = [...this.refusalReasons];
    }
    /** В случае если обновить не удастся я лучше заново сущность попрошу,
     * чем буду писать логику по сохранению прошлого состояния */

    return TenderParticipationService.updateItem(this.getPartner(), this.tender, false, result);
  }

  static parseRefusalReasons({ oldValue, newValue }: Diff<RefusalReason[]>): string {
    let result = '';

    if (Core.utils.isNotEmptyArray(oldValue)) {
      const oldNames: string[] = [];

      for (const _reason of oldValue) {
        oldNames.push(_reason.name);
      }

      result += ` с ${oldNames.join(', ')}`;
    }

    if (Core.utils.isNotEmptyArray(newValue)) {
      const newNames: string[] = [];

      for (const _reason of newValue) {
        newNames.push(_reason.name);
      }

      result += ` на ${newNames.join(', ')}`;
    } else {
      result += ' на причина не указана';
    }

    return result;
  }
}

export default ParticipationDetailProduct;